/**
 * Strategy sections that are dropped from the native stock page.
 * Deep links and scrollToSection for these open the stock screen only.
 */
export const NATIVE_STOCK_PAGE_STRATEGY_SECTION_IDS = Object.freeze([
  "donchain_h1",
  "donchain_h4",
  "ichimoku_h1",
  "ichimoku_h4",
  "transaction_strategy_highs_and_lows",
  "transaction_strategy_supply_demand",
  "transaction_strategy_trend"
]);

/** Path / query aliases that also map to dropped strategy sections. */
export const NATIVE_STOCK_PAGE_STRATEGY_SECTION_ALIASES = Object.freeze([
  "swing-and-direction",
  "highs-and-lows",
  "szczyty-i-dna"
]);

const STRATEGY_SECTION_SET = new Set([
  ...NATIVE_STOCK_PAGE_STRATEGY_SECTION_IDS,
  ...NATIVE_STOCK_PAGE_STRATEGY_SECTION_ALIASES
]);

/**
 * Chart / demand-zone deep links are not a collapsible stock section page.
 */
export const NATIVE_STOCK_PAGE_NON_SECTION_IDS = Object.freeze([
  "section-chart"
]);

/**
 * Legacy targets that are not a native section page (open stock screen only).
 * Analyses deep links / comments no longer scroll the stock list.
 */
export const NATIVE_STOCK_PAGE_LEGACY_SCROLL_SECTION_IDS = Object.freeze([
  "section-stock-analyses"
]);

const NON_SECTION_SET = new Set(NATIVE_STOCK_PAGE_NON_SECTION_IDS);
const LEGACY_SCROLL_SECTION_SET = new Set(
  NATIVE_STOCK_PAGE_LEGACY_SCROLL_SECTION_IDS
);

export function isNativeStockPageStrategySection(sectionParam) {
  if (!sectionParam || typeof sectionParam !== "string") {
    return false;
  }

  return STRATEGY_SECTION_SET.has(sectionParam);
}

export function isNativeStockPageLegacyScrollSection(sectionParam) {
  if (!sectionParam || typeof sectionParam !== "string") {
    return false;
  }

  return LEGACY_SCROLL_SECTION_SET.has(sectionParam);
}

export function canOpenNativeStockPageSection(sectionParam) {
  if (!sectionParam || typeof sectionParam !== "string") {
    return false;
  }

  if (isNativeStockPageStrategySection(sectionParam)) {
    return false;
  }

  if (NON_SECTION_SET.has(sectionParam)) {
    return false;
  }

  if (isNativeStockPageLegacyScrollSection(sectionParam)) {
    return false;
  }

  return true;
}
